import { render, staticRenderFns } from "./AccountsCard.vue?vue&type=template&id=2b1b691c"
import script from "./AccountsCard.vue?vue&type=script&lang=js"
export * from "./AccountsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports